import useResizeObserver from '@src/hooks/useResizeObserver';
import {isMobileViewport} from '@src/helpers/isMobileViewport';

export default function useIsMobileViewport() {
    const {width} = useResizeObserver();

    return isMobileViewport(width);
}
